<template>
  <section>
    <v-container fluid>
      <v-row justify="space-between" class=" align-center">
        <v-col cols="auto">
          <v-btn @click="openFormDialog" class="accent shadow-4 px-8" color="success" large rounded>
            Crear Gateway
          </v-btn>
        </v-col>
        <v-col cols="auto">
          <v-text-field
            filled
            rounded
            dense
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>

    <v-card class="shadow-1 mt-5 mt-md-10">
      <v-data-table
        :search="search"
        :headers="headers"
        :items="gatewayList"
        item-key="id"
        :loading="isLoading"
        :options.sync="options"
        :server-items-length="totalItems"
        no-data-text="No hay Gateways que mostrar"
        :footer-props="{
          'items-per-page-options': [15, 30, 50, 100],
        }"
      >
        <template v-slot:[`item.action`]="{ item }">
          <v-hover v-slot:default="{ hover }">
            <v-btn text icon :color="hover ? 'accent' : 'blue-grey'" @click.stop="handleEdit(item)">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </v-hover>
          <v-hover v-slot:default="{ hover }">
            <v-btn text icon :color="hover ? 'error' : 'blue-grey'" @click.stop="handleDelete(item)">
              <v-icon>mdi-trash-can-outline</v-icon>
            </v-btn>
          </v-hover>
        </template>
      </v-data-table>
    </v-card>

    <!-- Form dialog -->
    <contact-form
      v-if="isOpenForm"
      :isActive="isOpenForm"
      :isEditMode="isEditMode"
      :dataToEdit="gatewayToEdit"
      @close:dialog="closeFormDialog"
    ></contact-form>
    <!-- Delete Dialog -->
    <delete-dialog
      v-if="isOpenDelete"
      :isActive="isOpenDelete"
      :id="gatewayToDelete.id"
      @dialog:close="closeDeleteDialog"
    ></delete-dialog>
  </section>
</template>

<script>
import { PbxHttpClient } from "@/services/httpclient";
import ContactForm from "@/components/GatewaySettings/ContactForm.vue";
// import ImportDialog from "@/components/ContactSettings/ImportDialog.vue";
import DeleteDialog from "@/components/GatewaySettings/DeleteDialog.vue";

export default {
  name: "ContactList",

  components: { ContactForm, DeleteDialog },

  data() {
    return {
      isLoading: false,
      isOpenForm: false,
      isEditMode: false,
      isOpenDelete: false,
      search: "",
      // For pagination
      totalItems: 0,
      options: {
        page: 1,
        itemsPerPage: 15,
      },
      // End for pagination
      gatewayList: [],
      gatewayToEdit: {},
      gatewayToDelete: {},
      headers: [
        {
          text: "Nombre",
          align: "left",
          value: "name",
          class: "primary--text",
          width: "25%",
        },
        {
          text: "URL",
          value: "url",
          class: "primary--text",
          width: "20%",
        },
        {
          text: "API",
          value: "api",
          class: "primary--text",
          width: "20%",
        },
        {
          text: "Usuario",
          value: "user",
          class: "primary--text",
          width: "20%",
        },
        {
          text: "Acciones",
          value: "action",
          class: "primary--text",
          width: "12%",
          align: "left",
          sortable: false,
        },
      ],
    };
  },

  watch: {
    options: {
      handler() {
        this.getGateways();
      },
      deep: true,
    },
  },

  // created() {
  //   this.getGateways();
  // },

  methods: {
    async getGateways() {
      const page = this.options.page || 1;
      const itemPerPage = this.options.itemsPerPage || 15;
      this.isLoading = true;
      try {
        const { data } = await PbxHttpClient.get("/gateway", {
          params: { page, itemPerPage },
        });
        this.totalItems = data.total;
        this.gatewayList = data.data;
      } catch (err) {
        this.$snotify.error("No se pudo obtener los datos.", "¡Error!");
      }
      this.isLoading = false;
    },

    handleEdit(item) {
      this.isEditMode = true;
      this.gatewayToEdit = item;
      this.openFormDialog();
    },
    handleDelete(item) {
      this.gatewayToDelete = item;
      this.isOpenDelete = true;
    },

    openFormDialog() {
      this.isOpenForm = true;
    },
    closeFormDialog(data = false) {
      if (data && this.isEditMode) this.gatewayList = this.gatewayList.map((el) => (el.id === data.id ? data : el));
      if (data && !this.isEditMode) this.getGateways();
      this.isOpenForm = false;
      this.isEditMode = false;
      this.gatewayToEdit = {};
    },

    closeDeleteDialog(id = false) {
      if (id) this.gatewayList = this.gatewayList.filter((el) => el.id !== id);
      this.isOpenDelete = false;
    },
  },
};
</script>
